export const translations = {
  taxa: { 
    pt: 'Porcentagem da Taxa', 
    en: 'Rate Percentage', 
    de: 'Ratenprozentsatz', 
    es: 'Porcentaje de Tasa' 
},
  criadoEm: { 
    pt: 'Criado em', 
    en: 'Created at', 
    de: 'Erstellt am', 
    es: 'Creado en' 
},
usuario: { 
  pt: 'Criado por', 
  en: 'Created by', 
  de: 'Erstellt von', 
  es: 'Creado por' 
},
  deletadoEm: { 
    pt: 'Deletado em', 
    en: 'Deleted at', 
    de: 'Gelöscht am', 
    es: 'Eliminado en' 
},
  status: { 
    pt: 'Status', 
    en: 'Status', 
    de: 'Status', 
    es: 'Estado' 
},
  ativo: { 
    pt: 'Ativo', 
    en: 'Active', 
    de: 'Aktiv', 
    es: 'Activo' 
},
  inativo: { 
    pt: 'Inativo', 
    en: 'Inactive', 
    de: 'Inaktiv', 
    es: 'Inactivo' 
},
};